import React from 'react';
import { BrowserRouter as Router, Route, Routes, Navigate } from 'react-router-dom';
import Login from "./pages/login/Login";
import TopNav from "./components/TopNav";
import Dashboard from "./pages/dashboard/Dashboard";
import ForgotPasswordPage from "./pages/login/ForgotPasswordPage";
import ResetPasswordPage from './pages/login/ResetPasswordPage';
import "bootstrap/dist/css/bootstrap.min.css";

//css
import "./App.css";

//redux
import { useSelector } from "react-redux";

const ProtectedRoute = ({ children }) => {
  const token = localStorage.getItem('access_token');

  if (!token) {
    return <Navigate to="/login" replace />;
  }

  return children;
};

function App() {
  return (
    <Router>
      <TopNav />

      <div style={{ height: 'calc(100vh - 50px)', overflow: 'hidden' }}>
        <Routes>
          <Route path="/login" element={<Login />} />
          <Route path="/login/forgot-password" element={<ForgotPasswordPage />} />
          <Route path="/reset-password" element={<ResetPasswordPage />} />
          <Route
            path="/dashboard"
            element={
              <ProtectedRoute>
                <Dashboard />
              </ProtectedRoute>
            }
          />
          <Route path="/" element={<Navigate to="/login" />} />
        </Routes>
      </div>
    </Router>
  );
}

export default App;